<template>
	<p class="uppercase text-xs font-main-bold py-4" v-if="proposal && title">
		{{title}}
	</p>
</template>

<script>
	export default {
		name: 'SimpleProposalHeader',
		props: {
			title: {
				type: String,
				required: false,
				default: null
			},
			proposal: {
				type: Object,
				required: true,
				default: null
			}
		}
	}
</script>

<style lang="scss" scoped></style>
